// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"594":"about","652":"service","797":"industry"}[chunkId] || chunkId) + "." + {"594":"df12500d","652":"ecb704a2","752":"e3f15677","797":"68f72005"}[chunkId] + ".css";
};